import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import LiveSection from "./components/LiveSection";
import HotTopics from "./components/HotTopics";
import DanmakuWall from "./components/DanmakuWall";
import ConnectSection from "./components/ConnectSection";
import Columns from "./components/Columns";
import Testimonials from "./components/Testimonials";
import Faq from "./components/Faq";
import Footer from "./components/Footer";

function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <button
      aria-label="返回顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className={`fixed bottom-6 right-6 z-40 w-12 h-12 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 flex items-center justify-center text-xl shadow-lg transition-all duration-300 cursor-pointer ${
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      <i className="ri-arrow-up-line"></i>
    </button>
  );
}

export default function Home() {
  return (
    <div id="top" className="bg-background-50 min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <LiveSection />
        <HotTopics />
        <DanmakuWall />
        <ConnectSection />
        <Columns />
        <Testimonials />
        <Faq />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}